import React from 'react';
import { Typography, Box, useTheme, useMediaQuery } from "@mui/material";
import CustomAppBar from "../components/CustomAppBar";

export default function Question(props) {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));

    return (
        <Box
            sx={{
                minHeight: props.componentHeight || "calc(100vh - 4rem - 4rem)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                backgroundColor: props.backgroundColor || theme.palette.background.default,
            }}
        >
            {!props.landing && <CustomAppBar
                noBack={props.noBack}
                returning={props.returning}
                main={props.main}
                onBack={props.onBack}
            />}

            <Box
                sx={{
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                    px: { xs: "2rem", sm: "5rem", md: "10rem" },
                    pt: "clamp(1rem, 5vh, 6rem)",
                }}
            >
                <Box
                    sx={{
                        width: "100%",
                        maxWidth: isDesktop ? "600px" : "100%",
                        margin: "0 auto",
                        mb: "clamp(1rem, 3vh, 3rem)",
                    }}
                >
                    {props.heading && (
                        <Typography
                            variant="h5"
                            sx={{
                                mb: "clamp(1rem, 2vh, 2rem)",
                                fontSize: "clamp(16px, 4vh, 32px)",
                                textAlign: isDesktop ? "center" : "left",
                            }}
                        >
                            {props.heading}
                        </Typography>
                    )}

                    <Typography
                        variant="h5"
                        sx={{
                            fontFamily: "Sentient",
                            color: "#151515",
                            fontSize: "clamp(14px, 3vh, 28px)",
                            fontWeight: 400,
                            mt: "clamp(0.5rem, 1.5vh, 1.5rem)",
                            mb: "clamp(0.5rem, 1.5vh, 1.5rem)",
                            textAlign: isDesktop ? "center" : "left",
                        }}
                    >
                        {props.title}
                    </Typography>

                    <Box
                        sx={{
                            textAlign: isDesktop ? "center" : "left",
                            mb: "clamp(1rem, 3vh, 2rem)",
                            fontSize: "clamp(10px, 2.5vh, 14px)",
                        }}
                    >
                        {props.subtitle}
                    </Box>

                    <Box sx={{ width: "100%" }}>
                        {props.input}
                    </Box>
                </Box>
            </Box>

            {props.footer}
        </Box>
    );
}
